const n = {
  "cdr-label-standalone": "cdr-label-standalone_13-5-2",
  "cdr-label-standalone__label-wrapper": "cdr-label-standalone__label-wrapper_13-5-2",
  "cdr-label-standalone__label": "cdr-label-standalone__label_13-5-2",
  "cdr-label-standalone__label--sr-only": "cdr-label-standalone__label--sr-only_13-5-2",
  "cdr-label-standalone__label--disabled": "cdr-label-standalone__label--disabled_13-5-2",
  "cdr-label-standalone__optional": "cdr-label-standalone__optional_13-5-2",
  "cdr-label-standalone__helper": "cdr-label-standalone__helper_13-5-2",
  "cdr-label-standalone__info": "cdr-label-standalone__info_13-5-2",
  "cdr-label-standalone__post-content": "cdr-label-standalone__post-content_13-5-2",
  "cdr-label-standalone__info-action": "cdr-label-standalone__info-action_13-5-2",
  "cdr-label-standalone__input-wrap": "cdr-label-standalone__input-wrap_13-5-2",
  "cdr-label-standalone__input-spacing": "cdr-label-standalone__input-spacing_13-5-2",
  "cdr-form-error": "cdr-form-error_13-5-2",
  "cdr-form-error__icon": "cdr-form-error__icon_13-5-2",
  "cdr-input": "cdr-input_13-5-2",
  "cdr-input--focus": "cdr-input--focus_13-5-2",
  "cdr-input--multiline": "cdr-input--multiline_13-5-2",
  "cdr-input--preicon": "cdr-input--preicon_13-5-2",
  "cdr-input--posticon": "cdr-input--posticon_13-5-2",
  "cdr-input--posticons": "cdr-input--posticons_13-5-2",
  "cdr-input--primary": "cdr-input--primary_13-5-2",
  "cdr-input--secondary": "cdr-input--secondary_13-5-2",
  "cdr-input--error": "cdr-input--error_13-5-2",
  "cdr-input--large": "cdr-input--large_13-5-2",
  "cdr-input--large@xs": "cdr-input--large@xs_13-5-2",
  "cdr-input--large@sm": "cdr-input--large@sm_13-5-2",
  "cdr-input--large@md": "cdr-input--large@md_13-5-2",
  "cdr-input--large@lg": "cdr-input--large@lg_13-5-2",
  "cdr-input__pre-icon": "cdr-input__pre-icon_13-5-2",
  "cdr-input__post-icon": "cdr-input__post-icon_13-5-2",
  "cdr-input__helper-text": "cdr-input__helper-text_13-5-2",
  "cdr-input-wrap": "cdr-input-wrap_13-5-2"
};
export {
  n as default
};
